import { Table, Tbody, Td, Tr, Thead, Th } from '@/gf/components/Table'

import { AccountMachine } from '../../types'

const AccountMachinesTable = ({ accountMachines }: { accountMachines: AccountMachine[] }) => (
  <Table>
    <Thead>
      <Tr>
        <Th>Unit #</Th>
        <Th>Serial Number</Th>
        <Th>Make</Th>
        <Th>Model</Th>
        <Th>Year</Th>
        <Th>Engine Make</Th>
        <Th>Engine Model</Th>
        <Th>Engine Serial Number</Th>
      </Tr>
    </Thead>
    <Tbody>
      {accountMachines.map((accountMachine) => (
        <Tr key={accountMachine.name}>
          <Td>{accountMachine.name}</Td>
          <Td>{accountMachine.serialNumber}</Td>
          <Td>{accountMachine.make}</Td>
          <Td>{accountMachine.model}</Td>
          <Td>{accountMachine.year}</Td>
          <Td>{accountMachine.engineMake}</Td>
          <Td>{accountMachine.engineModel}</Td>
          <Td>{accountMachine.engineSerialNumber}</Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
)

export default AccountMachinesTable
